export default __webpack_public_path__ + "images/83693ce02e6369dbc716ccb8afac1bdd-menu-dog-play.svg";